import * as yup from "yup";

export const validationRegisterAccessFormSchema = yup.object().shape({
    discord: yup.string().required("Required "),
    workoutPerWeek: yup.string().required("Required "),
    machineSerial: yup
        .string()
        .required("Required "),
    isAgree: yup.boolean().required(""),
});
